import { Filter, FilterResult } from '../Filter/Types';
import { objectToQueryString } from './Util';

function makeFilterQuery(filter: Filter | null): string {
    if (!filter) {
        return '';
    } else if (filter.type === 'skinAnalysis') {
        return 'filterType=skinAnalysis&filter=' + filter.skinAnalysisId;
    } else if (filter.type === 'standardFilter') {
        return 'filterType=standard&filter=' + filter.values.age + ';' + filter.values.skinAppearance;
    } else if (filter.type === 'onlineAnalysis') {
        return 'filterType=onlineAnalysis&' + objectToQueryString(filter.values);
    } else {
        return '';
    }
}

export function getFilteredProducts(
    nodeId: string,
    filter: Filter | null,
    onSuccess: (result: FilterResult[]) => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch('/api/category/' + nodeId + '/product?' + makeFilterQuery(filter), {
        method: 'get',
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while fetching filtered products', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export function getProductCustomerSpecificData(
    articleNumber: string,
    filter: Filter | null,
    onSuccess: (result: FilterResult) => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    const queryParams = [];
    const filterQuery = makeFilterQuery(filter);
    if (filterQuery) {
        queryParams.push(filterQuery);
    }
    if (window.__GGCareSectionId) {
        queryParams.push('careSectionId=' + window.__GGCareSectionId);
    }
    const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : '';

    fetch('/api/product/' + articleNumber + '/customerSpecificData' + queryString, {
        method: 'get',
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while fetching customer specific product data', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}
